import { DocumentProps, pdf } from '@react-pdf/renderer'
import { useSession } from 'components/auth/useSession'
import { PromiseErrorContextValue } from 'components/error'
import { useConfiguracoes } from 'hooks/configuracoes'
import { useServerTime } from 'hooks/useServerTime'
import { previewFile } from 'util/previewFile'

import { PecPrintPageLayout, PecPrintPageLayoutProps } from './layout/PecPrintPageLayout'
import { PrinterType } from './model-print'

interface PrintDocumentBody extends Omit<PecPrintPageLayoutProps, 'serverTime'> {
  docBody: React.ReactElement
}

export const usePrinter = (session?: PrinterType) => {
  const { data } = useSession({ fetchPolicy: 'cache-only' })
  const { getServerTimeNow } = useServerTime()
  const {
    configuracoes: { treinamento },
  } = useConfiguracoes()

  const printPDF = (
    documentBody: PrintDocumentBody,
    handleRejection: PromiseErrorContextValue,
    audit?: Function,
    signatureDate?: Date
  ) => {
    const document = renderDocument(
      documentBody,
      session ?? data,
      data.profissional.nome,
      getServerTimeNow(),
      signatureDate,
      treinamento
    )

    pdf(document)
      .toBlob()
      .then((blob) => {
        previewFile(blob, 'pdf')
      })
      .then(() => {
        audit && audit()
      })
      .catch((error) => {
        handleRejection(error)
      })
  }
  return { printPDF }
}

const renderDocument = (
  documentBody: PrintDocumentBody,
  session: PrinterType,
  nameFooter: string,
  serverTime: Date,
  signatureDate?: Date,
  invalido?: boolean
): React.ReactElement<DocumentProps> => {
  const { docBody, ...rest } = documentBody

  return (
    <PecPrintPageLayout
      session={session}
      nameFooter={nameFooter}
      serverTime={serverTime}
      signatureDate={signatureDate}
      invalido={invalido}
      {...rest}
    >
      {docBody}
    </PecPrintPageLayout>
  )
}
